import { render, staticRenderFns } from "./TiHuo.vue?vue&type=template&id=6f68b058&scoped=true&"
import script from "./TiHuo.vue?vue&type=script&lang=js&"
export * from "./TiHuo.vue?vue&type=script&lang=js&"
import style0 from "./TiHuo.vue?vue&type=style&index=0&id=6f68b058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68b058",
  null
  
)

export default component.exports